import { startApplication } from './app/core/config/start-application';

// R-001: runtime configuration resolves before bootstrap; on failure the
// full-page error with Retry renders instead (FR-034). See start-application.ts.
//
// AITH-121 replaced the authorize popup with a top-level redirect, so the
// authorization response is delivered to THIS window and is processed by
// AuthFlowService.completeBootstrapCallback during bootstrap. The pre-bootstrap
// popup bridge that used to gate this call is gone: with no popup it could
// never fire on the intended path, and on the one path it still could — a
// document that happens to have a `window.opener` and lands on
// `/sign-in?code=…&state=…`, which is now simply the normal callback URL — it
// would have postMessage'd the response away and left a blank page instead of
// bootstrapping (AITH-121 PR #19 sweep).
void startApplication();
